var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f26738;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.2,10l2.19.46a18.1,18.1,0,1,1-6.92-.26l1-.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M55.28,48.65c-4.36,8.52-4.17,16.75,1.93,24.18s14.09,9.25,23.26,6.68c0,2.81,0,5.62,0,8.43a2.25,2.25,0,0,1-2.11,2c-.24,0-.47,0-.71,0H13c-2,0-2.85-.83-2.85-2.82,0-2.61-.05-5.21,0-7.81A34.58,34.58,0,0,1,21.75,53.75a33.26,33.26,0,0,1,10.32-6.48,1.21,1.21,0,0,1,1,.08A22.77,22.77,0,0,0,48,50.77,22.06,22.06,0,0,0,54.47,49Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M73.46,43.13A16.41,16.41,0,1,0,89.85,59.57,16.38,16.38,0,0,0,73.46,43.13ZM80,62.9c-1,0-2,0-3.14,0,0,1.08,0,2.08,0,3.08a3.39,3.39,0,1,1-6.75,0c0-1,0-1.94,0-3-1.07,0-2.06,0-3.06,0a3.38,3.38,0,1,1,0-6.74c1,0,1.94,0,3.08,0,0-1,0-2,0-2.92,0-2.24,1.43-3.83,3.39-3.82s3.35,1.6,3.36,3.85c0,.93,0,1.85,0,2.89,1.11,0,2.11,0,3.11,0a3.38,3.38,0,1,1,0,6.74Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateUser);
export default __webpack_public_path__ + "static/media/createUser.28ea65fbf802a6362015068f1090f9d4.svg";
export { ForwardRef as ReactComponent };